import React from 'react';
import cx from 'classnames';

import ChevronS1Down from '../Icons/ChevronS1Down';
import ChevronS2Down from '../Icons/ChevronS2Down';
import Touchable, { TouchableProps } from '../Touchable';

import baseStyles from '../PrimaryLink/PrimaryLink.module.scss';
import styles from './DropdownLink.module.scss';

export interface Props extends Omit<TouchableProps, 'href'> {
  onClick: (event: React.MouseEvent) => void;
  expanded: boolean;
}

export const DropdownLink: React.FC<Props> = ({
  children,
  className,
  disabled,
  expanded,
  size,
  ...restProps
}) => (
  <Touchable
    {...restProps}
    size={size != null ? size : 16}
    className={cx(
      baseStyles.baseLink,
      baseStyles.primaryLink,
      disabled && baseStyles.disabled,
      className,
    )}
    disabled={disabled}
  >
    {children}
    {size === 14 ? (
      <ChevronS2Down
        className={cx(styles.chevron, expanded && styles.expanded)}
      />
    ) : (
      <ChevronS1Down
        className={cx(styles.chevron, expanded && styles.expanded)}
      />
    )}
  </Touchable>
);

DropdownLink.displayName = 'DropdownLink';
export default DropdownLink;
export { styles };
